import React from "react";
import productImg from "../../../assets/images/product1.png";

const SelectedConfiguration = ({ orderProductTab, attributeDetails }) => {
    return (
        <div className="row">
            <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 my-auto">
                <div className="collapse test" id="collapseSelectedConfiguration">
                    <div className="card">
                        <div className="card-body">
                            <div className="row mt-2">
                                <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 my-auto">
                                    <div className="d-flex">
                                        <div className="text-center">
                                            <img src={productImg} alt="Product" />
                                            <h6>{orderProductTab?.data?.productName}</h6>
                                        </div>
                                        <div className="w-100 overflow-auto">
                                            <div className="content">
                                                {attributeDetails?.map((config, index) => (
                                                    <div key={index} className="flex-column">
                                                        <h5>
                                                            {config?.attributeValue === "Custom Colour"
                                                                ? config?.specialValue
                                                                : config?.attributeValue || config?.specialValue
                                                            }
                                                        </h5>
                                                        <label>{config?.attributeName}</label>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SelectedConfiguration